<div class="menuLeft" [class.show]="ui.mobileMenuOpen()">
  <ul class="menuWrapper">
    <li class="mainItem home" [class.active]="activeItem() === 'home'">
      <a href="/menu.html" class="bsrBack functionsLogo" data-transaction-name="Back" insp-label="Back" [title]="'itgen_gmr_home' | translate | decodeEntities" translate="itgen_gmr_home" (click)="ui.goToFunctionPicker($event)"></a>
    </li>
  </ul>

  @for (entry of data.groupedFunctions() | keyvalue: originalOrder; track entry.key)
  {
    <div class="menuGroup" [class.custom]="entry.value[0].can_custom_flag === true">
      <!-- Same accordion treatment as the tile grid's group header; see the comment in
           function-picker.component.html. The `group-nav-` prefix keeps these ids distinct from the
           grid's, since both surfaces render a header for every group. -->
      <div class="reportGroupHeader">
        <h3 class="reportGroupHeading">
          <button type="button" class="reportGroupToggle"
                  [id]="'group-nav-' + entry.value[0].can_description"
                  [attr.aria-expanded]="!isGroupCollapsed(entry.key)"
                  [attr.aria-controls]="'group-nav-list-' + entry.value[0].can_description"
                  (click)="toggleGroupCollapse(entry.key)"
                  [translate]="entry.value[0].can_description"></button>
        </h3>
        <span class="closeGroup" aria-hidden="true" [class.collapse]="isGroupCollapsed(entry.key)" (click)="toggleGroupCollapse(entry.key)"></span>
      </div>
      <!-- .menuWrapper.functionsList defaults to display:none in menu.css (jQuery's fadeToggle
           un-hid it to its natural 'block' on open) - an empty string here would just clear the
           inline override and fall back to that CSS default, leaving it hidden even when "open". -->
      <ul class="functionsList menuWrapper" [id]="'group-nav-list-' + entry.value[0].can_description" [style.display]="isGroupCollapsed(entry.key) ? 'none' : 'block'">
        @for (fn of entry.value; track fn.cfn_code)
        {
          <li class="menuItem" [class.active]="activeItem() === fn.cfn_preset_name">
            @if (entry.value[0].can_custom_flag === true)
            {
              <span class="customLabel">custom</span>
            }
            <!-- `nav-` prefix, mirroring the grid's `tile-`; see function-picker.component.html. -->
            <a href="#preset={{ fn.cfn_preset_name }}" [id]="'nav-' + fn.cfn_preset_name"
               [class.icon]="fn.cfn_icon_url != null" [class.goParam]="fn.cfrstat_cnt >= 1"
               [attr.data-value]="fn.cfn_code" [attr.data-preset-name]="fn.cfn_preset_name"
               [title]="(fn.cfn_description | translate) | decodeEntities"
               (click)="selectFunction(fn)">
              <img class="menuIcon" [src]="fn.cfn_icon_url" [alt]="(fn.cfn_description | translate) | decodeEntities" [title]="(fn.cfn_description | translate) | decodeEntities" />
              <span class="functionDescription" [translate]="fn.cfn_description"></span>
            </a>
          </li>
        }
      </ul>
    </div>
  }
</div>
